import React from "react";
import { UserCog } from "lucide-react";

/* 「由销售助理 X 代操作」徽标：记录上有 actedBy{name, forName} 时显示 */
export function ActedByBadge({ actedBy, zh = true, tid }) {
  if (!actedBy) return null;
  return (
    <span data-testid={tid || "acted-by-badge"} data-assistant={actedBy.username} title={zh ? `销售助理 ${actedBy.name} 代 ${actedBy.forName || ""} 操作` : `Assistant ${actedBy.name} on behalf of ${actedBy.forName || ""}`}
      className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-violet-50 text-violet-700 border border-violet-200 font-medium whitespace-nowrap">
      <UserCog className="h-3 w-3" />{zh ? `由销售助理 ${actedBy.name} 代操作` : `By assistant ${actedBy.name}`}
    </span>
  );
}
